import { colors } from '@kmns-internal/furikake'
import { Box } from '@mui/material'
import type { ReactNode } from 'react'

type Props = {
  children: ReactNode
  isActive?: boolean
}

export const DayHeaderCell = (props: Props) => {
  const { children, isActive = false } = props

  return (
    <Box
      sx={{
        color: isActive ? colors.primary.main : 'inherit',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      {children}
    </Box>
  )
}
